import styled from "styled-components";
import ButtonRow from "components/ButtonRow";
import { pageTitle } from "styles/typography";

export const Message = styled.p`
  margin: 17px 0;
  font-size: 26px;
  ${pageTitle}
  color: ${(props) => props.theme.black};
`;

export const ButtonsWrapper = styled(ButtonRow)`
  width: 100%;
  padding: 5px 0;
`;
